// Converte um texto da regra 3 ("Só a primeira") para a regra 2 ("Cada
// Palavra") do guia de UI (docs/design/ui.md, seção Texto). O domínio
// devolve seus textos na regra 3; quem precisa exibir na regra 2 (célula,
// opção de lista, título) passa por aqui em vez de duplicar a grafia à mão.

/** Palavras que ficam minúsculas quando não abrem o texto. */
const MINUSCULAS = new Set([
  "de", "da", "do", "das", "dos", "em", "na", "no", "nas", "nos",
  "por", "pela", "pelo", "pelas", "pelos", "para", "com", "sem",
  "a", "ao", "aos", "à", "às", "até", "entre", "sobre",
  "o", "os", "as", "um", "uma",
  "e", "ou", "nem",
  // pronomes: demonstrativos, possessivos e relativos
  "este", "esta", "estes", "estas", "esse", "essa", "esses", "essas", "isto", "isso",
  "aquele", "aquela", "aqueles", "aquelas", "aquilo",
  "meu", "minha", "meus", "minhas", "seu", "sua", "seus", "suas",
  "que", "se", "lhe", "lhes",
]);

/** Símbolos de unidade de medida: minúsculos em qualquer regra (regra 4). */
const UNIDADES = new Set(["kg", "g", "mg", "l", "ml", "m", "cm", "mm", "km", "h", "min", "s", "un"]);

const PALAVRA = /\p{L}[\p{L}\p{N}]*/gu;

/** Sigla: duas ou mais maiúsculas seguidas ("OS", "KPIs", "CNPJ"). */
const SIGLA = /^\p{Lu}{2,}/u;

/** Início do complemento explicativo, que é frase (regra 3) e fica como está. */
const COMPLEMENTO = /\s—\s|\(/;

export function emTitulo(texto: string): string {
  const corte = texto.search(COMPLEMENTO);
  if (corte > 0) return emTitulo(texto.slice(0, corte)) + texto.slice(corte);
  return texto.replace(PALAVRA, (palavra: string, pos: number) => {
    // Extensão de arquivo (".csv") é grafia técnica, não palavra.
    if (SIGLA.test(palavra) || UNIDADES.has(palavra) || texto[pos - 1] === ".") return palavra;
    // Abre o texto quem vem no início ou logo depois de uma barra.
    const antes = texto.slice(0, pos).trimEnd();
    const abre = antes === "" || antes.endsWith("/");
    if (!abre && MINUSCULAS.has(palavra.toLowerCase())) return palavra.toLowerCase();
    return palavra.charAt(0).toUpperCase() + palavra.slice(1);
  });
}
